// extracted by mini-css-extract-plugin
module.exports = {"root":"root","colorWeak":"colorWeak","ant-layout":"ant-layout","globalSpin":"globalSpin"};